import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Flow } from '../obj/Flow';

@Component({
    selector: 'app-success-line',
    templateUrl: './success-line.component.html',
    styleUrls: ['./success-line.component.css'],
    standalone: false
})
export class SuccessLineComponent implements OnInit {

  @Input()
  public item: Flow = null;

  runsSparkline: any = [];

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) { }

  ngOnInit() {

    // this.item._sparkline = this.item.runs.map(run=>{
    //   return [
    //       run.duration,
    //       null,
    //       (run.status == "Succeeded" ? '#228B22' : '#C21807')
    //   ]
    // });
    this.runsSparkline = this.item.runsSparkline;

    // setTimeout(()=>{
    //   if (this.item){
    //     this.runsSparkline = this.item.runsSparkline;
    //   }
  
    // }, 100);
  }

  getSafeUrl(url): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  public async doGetRuns(flow: Flow) {
    if (!flow?.environment || !flow?.flowName) return;
    this.router.navigate(['/flows', flow.environment, flow.flowName, 'runs']);
  }


}
